/* eslint-disable react/no-unknown-property */
function LightsIntro() {
  return (
    <>
      <ambientLight intensity={0.40} />
      <pointLight intensity={0.75} position={[400, 900, 1000]} />
    </>
  );
}

export default LightsIntro;
